module.exports = __webpack_public_path__ + "resources/img/zoom-ui-customizations-06.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/zoom-ui-customizations-06.png
// module id = 1402
// module chunks = 0